export default __webpack_public_path__ + "static/1272-4a8fcae8e6a0cb1694bf8fcf0e44282e.gif";